import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import { GameViewModel } from '../../resources/js/typings/viewModels/gameViewModel';
import SeoViewModel from '../../resources/js/typings/viewModels/seoViewModel';
import { BuildsSpecPageSlugsViewModel } from './getBuildsSpecPageSlugs';
import { SelectListItem } from '../../resources/js/typings/viewModels/selectListItemViewModel';
import SpecsByClassSelectItemViewModel from '../../resources/js/typings/viewModels/specsByClassSelectItemViewModel';
import { BuildsSectionComponentViewModel } from '../../resources/js/components/BuildsSectionComponent/BuildsSectionComponent';
import getCommonViewModels, { CommonViewModels } from './getCommonViewModels';
import { BuildsAdvancedSettingsViewModel } from '@resources/js/components/BuildsAdvancedSettings/BuildsAdvancedSettings';
import { BreadcrumbViewModel } from '../components/ArchonHeader/ArchonHeader';
import { RetailWarcraftTalentTreeBlueprint } from '@resources/js/typings/viewModels/retailWarcraftTalentTreeBuildNode';

export type BuildsSpecPageViewModel = {
  seo: SeoViewModel;
  breadcrumbs: BreadcrumbViewModel[];
  title: string;
  description: string;
  lastUpdatedLabel: string;
  lastUpdated: string | null;
  totalParsesLabel: string;
  totalParses: number;
  imageUrl: string | null;
  classLabel: string;
  specLabel: string;
  specOptions: SpecsByClassSelectItemViewModel[];
  selectedSpec: number;
  zoneTypeLabel: string;
  zoneTypeOptions: SelectListItem<string>[];
  selectedZoneType: string;
  categoryOptions: SelectListItem<string>[];
  sectionOptions: SelectListItem<string>[];
  selectedCategory: string;
  showDifficultySelect: boolean;
  difficultyLabel: string;
  difficultyOptions: SelectListItem<string>[];
  selectedDifficulty: string;
  encounterLabel: string;
  encounterOptions: SelectListItem<string>[];
  selectedEncounter: string;
  affixesLabel: string;
  affixesOptions: SelectListItem<string>[];
  selectedAffixes: string;
  talentTreeBlueprints: Record<string, RetailWarcraftTalentTreeBlueprint>;
  sections: BuildsSectionComponentViewModel[];
  advancedSettings: BuildsAdvancedSettingsViewModel;
  metadataSummaryDescription: string;
  warning: string | null;
  archonTitleBadgeLabel?: string;
  archonTitleBadgeTooltip?: string;
};

async function getBuildsSpecPageViewModels(
  slugs: BuildsSpecPageSlugsViewModel,
  translationKeys: string[]
): Promise<
  CommonViewModels & {
    game: GameViewModel;
    translations: Record<string, string>;
    buildsSpecPage: BuildsSpecPageViewModel | null;
  }
> {
  const data = await fetchJsonFromRpgLogsApi(
    `
query(
  $gameSlug: String!,
  $specSlug: String!,
  $classSlug: String!,
  $zoneTypeSlug: String!,
  $categorySlug: String!,
  $difficultySlug: String!,
  $encounterSlug: String!,
  $affixesSlug: String,
  $translationKeys: [String!]!
) {
  viewModels {
    game
    buildsSpecPage(
      gameSlug: $gameSlug,
      specSlug: $specSlug,
      classSlug: $classSlug,
      zoneTypeSlug: $zoneTypeSlug,
      categorySlug: $categorySlug,
      difficultySlug: $difficultySlug,
      encounterSlug: $encounterSlug,
      affixesSlug: $affixesSlug
    )
    translations(keys: $translationKeys)
  }
}
`,
    {
      ...slugs,
      translationKeys,
    },
    slugs.gameSlug
  );

  return {
    ...(await getCommonViewModels(slugs.gameSlug)),
    ...data.viewModels,
  };
}

export default getBuildsSpecPageViewModels;
